import React from 'react';

export const PhoneSVG = props => (
  <svg width={15} height={15} {...props}>
    <title>{"icons/phone"}</title>
    <defs>
      <path
        d="M9.005 8.978c1.922-1.92 2.622-3.141 2.1-3.662l-.142-.143c-.356-.355-.6-.64-.73-.853-.13-.213-.154-.533-.071-.96.083-.427.374-.948.872-1.564.237-.285.457-.516.658-.694.202-.178.41-.272.623-.284.214-.012.392-.018.534-.018.143 0 .315.077.516.231.202.154.344.26.427.32.083.06.238.208.463.445.226.237.35.367.374.39.57.57.534 1.72-.107 3.45-.64 1.73-1.85 3.472-3.63 5.226-1.78 1.778-3.53 2.993-5.25 3.645-1.72.652-2.865.693-3.435.124a59.57 59.57 0 0 0-.41-.391 7.06 7.06 0 0 1-.444-.444 18.36 18.36 0 0 1-.32-.427c-.167-.225-.244-.409-.232-.551.012-.142.024-.32.036-.534.012-.213.1-.42.267-.622.166-.201.391-.42.676-.658.498-.403.914-.681 1.246-.835.332-.154.652-.166.96-.036.31.13.517.237.624.32.106.083.338.303.694.658.522.522 1.756-.19 3.701-2.133z"
        id="prefix__a"
      />
    </defs>
    <use fill="#CCD0D2" xlinkHref="#prefix__a" fillRule="evenodd" />
  </svg>
)

export const MailSVG = props => (
  <svg width={16} height={12} {...props}>
    <title>{"icons/mail"}</title>
    <defs>
      <path
        d="M15.2 6.153v5.865c0 .65-.579 1.182-1.286 1.182H2.086C1.379 13.2.8 12.668.8 12.018V6.153c.241.244.514.458.812.643 1.334.835 2.684 1.67 3.993 2.548.675.458 1.511 1.02 2.387 1.02h.016c.876 0 1.712-.562 2.387-1.02a154.97 154.97 0 0 1 4.001-2.548c.29-.185.563-.399.804-.643zm0-2.171c0 .827-.667 1.573-1.374 2.024-1.254.797-2.515 1.595-3.76 2.4-.523.333-1.407 1.012-2.058 1.012h-.016c-.65 0-1.535-.68-2.057-1.012-1.246-.805-2.507-1.603-3.753-2.4C1.612 5.65.8 4.816.8 4.144.8 3.42 1.226 2.8 2.086 2.8h11.828c.7 0 1.286.532 1.286 1.182z"
        id="prefix__b"
      />
    </defs>
    <use
      fill="#CCD0D2"
      xlinkHref="#prefix__b"
      transform="translate(0 -2)"
      fillRule="evenodd"
    />
  </svg>
)

export const LinkSVG = props => (
  <svg width={14} height={14} {...props}>
    <title>{"icons/link"}</title>
    <defs>
      <path
        d="M13.712 9.387l-1.629-1.629a2.174 2.174 0 0 0-1.597-.657c-.637 0-1.18.23-1.628.689l-.69-.69c.46-.448.69-.993.69-1.635 0-.627-.217-1.157-.65-1.59l-1.613-1.62a2.145 2.145 0 0 0-1.597-.666c-.626 0-1.156.217-1.59.65l-1.15 1.143a2.136 2.136 0 0 0-.666 1.59c0 .626.22 1.158.658 1.596l1.628 1.629c.439.438.971.657 1.597.657.637 0 1.18-.23 1.629-.689l.689.69c-.46.448-.69.994-.69 1.636 0 .626.217 1.156.65 1.59l1.614 1.62c.433.443.965.665 1.597.665.626 0 1.155-.217 1.589-.65l1.15-1.143c.444-.433.666-.963.666-1.59 0-.625-.219-1.158-.657-1.596zm-6.608-3.35a18.852 18.852 0 0 1-.145-.15 4.856 4.856 0 0 0-.168-.168 1.893 1.893 0 0 0-.149-.117.631.631 0 0 0-.415-.13.725.725 0 0 0-.532.22.724.724 0 0 0-.22.532.629.629 0 0 0 .13.415c.05.068.088.117.117.149.029.031.085.087.168.168l.15.145a.757.757 0 0 1-.564.243.722.722 0 0 1-.533-.212L3.315 5.504a.725.725 0 0 1-.22-.533c0-.203.073-.378.22-.524l1.15-1.143a.756.756 0 0 1 .533-.212c.209 0 .386.074.532.22l1.613 1.62a.76.76 0 0 1-.04 1.104zm5.543 5.471l-1.15 1.143a.755.755 0 0 1-.533.204.721.721 0 0 1-.533-.211L8.82 11.023a.725.725 0 0 1-.22-.532c0-.22.087-.41.259-.572l.145.149a1.859 1.859 0 0 0 .317.286.627.627 0 0 0 .415.129.725.725 0 0 0 .532-.22.725.725 0 0 0 .22-.531.626.626 0 0 0-.13-.415 1.89 1.89 0 0 0-.117-.15A5.198 5.198 0 0 0 10.07 9l-.149-.144a.746.746 0 0 1 .564-.25c.209 0 .386.072.532.218l1.629 1.629c.146.146.22.323.22.532a.715.715 0 0 1-.22.524z"
        id="prefix__c"
      />
    </defs>
    <use
      fill="#CCD0D2"
      xlinkHref="#prefix__c"
      transform="translate(-1 -1)"
      fillRule="evenodd"
    />
  </svg>
)

export const FaxSVG = props => (
  <svg width={14} height={13} {...props}>
    <title>{"icons/fax"}</title>
    <defs>
      <path
        d="M4.8 12v2.4h6.4v-4H4.8V12zm.8-.8h4.8v.8H5.6v-.8zm0 1.6h4.8v.8H5.6v-.8zm5.6-8v1.6H4.8v-4h6.4v2.4zm1.6 0c.8 0 1.6.8 1.6 1.6v4c0 .8-.8 1.6-1.6 1.6H12V9.6H4V12h-.8c-.8 0-1.6-.8-1.6-1.6v-4c0-.8.8-1.6 1.6-1.6H4V7.2h8V4.8h.8z"
        id="prefix__d"
      />
    </defs>
    <use
      fill="#CCD0D2"
      xlinkHref="#prefix__d"
      transform="translate(-1 -2)"
      fillRule="evenodd"
    />
  </svg>
)
